<template>
  <article ref="main" class="local_navbar">
    <div>
      <a
        @click="scrollToSectionWithId(link.href)"
        v-for="(link, index) in targetProjectLinks"
        :key="index"
        :download="link.download"
        :href="link.download ? link.href : null"
        :target="link.download ? '_blank' : null"
        :class="{
          downloadLink: link.download,
          'hide-md': link.Hide,
          'wow fadeInDown': true,
        }"
      >
        {{ link.val }}
        <i v-if="link.download" class="fas fa-cloud-arrow-down" />
      </a>
    </div>
  </article>
</template>

<script>
export default {
  name: "ProjectPageInnerNav",
  props: ["targetProject", "scrollToSectionWithId"],
  data() {
    return {
      i: 0,
    };
  },
  methods: {
    getActiveLinks() {
      const obj = this.targetProjectLinks;
      return obj["download"]
        ? Object.keys(obj).length - 1
        : Object.keys(obj).length;
    },
  },
  computed: {
    innerNavTitles() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].projects.innerNavTitles;
    },
    targetProjectLinks() {
      const { innerNavTitles, targetProject } = this;
      console.log({ innerNavTitles });
      let targetProjectLinks = JSON.parse(JSON.stringify(innerNavTitles));

      !targetProject.descriptionVideoLink
        ? delete targetProjectLinks["descriptionVideo"]
        : null;

      !targetProject.pricingList ? delete targetProjectLinks["pricing"] : null;

      !targetProject.designYourNeeds
        ? delete targetProjectLinks["designYourNeeds"]
        : null;

      !targetProject.trailerVersoinLink ||
      targetProject.trailerVersoinLink === ""
        ? delete targetProjectLinks["download"]
        : (targetProjectLinks["download"].href =
            targetProject.trailerVersoinLink);

      let visibleLinks = Object.values(targetProjectLinks).filter(
        (item) => !item.Hide
      ).length;

      if (visibleLinks < 3) {
        for (const key of Object.keys(targetProjectLinks).filter(
          (key) => targetProjectLinks[key].Hide
        )) {
          targetProjectLinks[key].Hide = false;
          visibleLinks++;
          if (visibleLinks == 3) {
            break;
          }
        }
      }

      return targetProjectLinks;
    },
  },
};
</script>

<style></style>
